import AdvancedController from "../lib/advanced-controller";
import { gsap } from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

export default class Scene03Controller extends AdvancedController {
  static targets = ["container", "content", "fact"];

  static values = {};

  connect() {
    super.connect();

    const BASE_ANIMATION_TIME = 3;

    this.timeline = gsap.timeline({
      onUpdate: this.onUpdate.bind(this),
      scrollTrigger: {
        // trigger: this.containerTarget,
        start: "-64px top",
        pin: this.containerTarget,
        end: "1000%",
        scrub: 0.5,
        // markers: { startColor: "green", endColor: "red", fontSize: "12px" }
      },
    });

    let introKv1AnimProps = { x: "100%", filter: "blur(40px)" };
    let introKv2AnimProps = {
      x: "0%",
      filter: "blur(0px)",
      duration: BASE_ANIMATION_TIME,
      ease: "power2.out",
    };
    let outroKv1AnimProps = { x: "0%", filter: "blur(0px)" };
    let outroKv2AnimProps = {
      x: "-100%",
      filter: "blur(40px)",
      display: "none",
      duration: BASE_ANIMATION_TIME,
      ease: "power2.in",
    };

    if (window.innerWidth < 992) {
      delete introKv1AnimProps.filter;
      introKv1AnimProps.opacity = 0;

      delete introKv2AnimProps.filter;
      introKv2AnimProps.opacity = 1;

      delete outroKv1AnimProps.filter;
      outroKv1AnimProps.opacity = 1;

      delete outroKv2AnimProps.filter;
      outroKv2AnimProps.opacity = 0;
    }

    if (this.hasContentTarget) {
      this.timeline
        .fromTo(this.contentTarget, introKv1AnimProps, introKv2AnimProps)
        .fromTo(
          this.contentTarget,
          { opacity: 1 },
          { opacity: 1, duration: BASE_ANIMATION_TIME, ease: "none" }
        )
        .fromTo(this.contentTarget, outroKv1AnimProps, outroKv2AnimProps)
        .to(document.body, { opacity: 1, duration: BASE_ANIMATION_TIME });
    }

    let i = 0;
    const randomXValueBounds = window.innerWidth < 768 ? 35 : 50;
    const randomX = gsap.utils.random(
      -1 * randomXValueBounds,
      randomXValueBounds,
      true
    );
    const randomY = gsap.utils.random(40, 75, true);

    let factIntroAnimProps = {
      filter: "blur(0px)",
      duration: 1 * BASE_ANIMATION_TIME,
      ease: "none",
    };
    let factOutroAnimProps = {
      filter: "blur(80px)",
      duration: 1 * BASE_ANIMATION_TIME,
      ease: "none",
    };

    if (window.innerWidth < 992) {
      factIntroAnimProps.opacity = 1;
      factIntroAnimProps.filter = "blur(0px)";
      factOutroAnimProps.opacity = 0;
      factOutroAnimProps.filter = "blur(0px)";
    }

    for (const fact of this.factTargets) {
      const rX = randomX();
      const rY = randomY();

      const t = gsap
        .timeline()
        .to(fact, factIntroAnimProps)
        .to(
          fact,
          {
            scale: 2,
            x: `${rX}vw`,
            y: `${rY}vh`,
            duration: 3 * BASE_ANIMATION_TIME,
            ease: "none",
          },
          "<"
        )
        .to(fact, factOutroAnimProps, "<66%")
        .to(
          fact,
          {
            opacity: 0,
            duration: 1 * BASE_ANIMATION_TIME,
            ease: "none",
            display: "none",
          },
          "<50%"
        );

      let offset = i === 0 ? ">" : "<50%";
      this.timeline.add(t, offset);

      i += 1;
    }
  }

  onUpdate() {
    this.sendMessage(
      this.debugController,
      "messageProgress",
      this.timeline.progress()
    );
  }

  messageDebugInit(debugController) {
    this.debugController = debugController;
    this.hasDebugController = true;
  }

  messageProgress(progress) {
    this.timeline.pause();
    this.timeline.progress(progress);
  }

  messageTogglePlayPause() {
    if (this.timeline.paused()) {
      this.timeline.play();
    } else {
      this.timeline.pause();
    }
  }
}
